import { ECommerceMarketing } from "../features/e-commerce/pages/e-comm-marketing"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function ECommerceMarketingPage() {
  return (
    <DashboardLayout>
      <ECommerceMarketing />
    </DashboardLayout>
  )
}
